var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfettiCredit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 120,
    viewBox: "0 0 800 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 120,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_469_6008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M366.667 60.0001H433.334V43.3334H366.667V60.0001ZM429.167 101.667V89.1667H416.667V80.8334H429.167V68.3334H437.501V80.8334H450.001V89.1667H437.501V101.667H429.167ZM366.667 93.3334C364.376 93.3334 362.415 92.5181 360.784 90.8876C359.153 89.257 358.337 87.2945 358.334 85.0001V35.0001C358.334 32.7084 359.151 30.7473 360.784 29.1167C362.417 27.4862 364.378 26.6695 366.667 26.6667H433.334C435.626 26.6667 437.588 27.4834 439.221 29.1167C440.855 30.7501 441.67 32.7112 441.667 35.0001V60.0001H429.167C423.403 60.0001 418.491 62.032 414.43 66.0959C410.369 70.1598 408.337 75.0723 408.334 80.8334V93.3334H366.667Z",
    fill: "#22E06C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_469_6008"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(350 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfettiCredit);
export default __webpack_public_path__ + "static/media/confetti_credit.b9e1c3ed3878c58ff24d49ed81bbf0b9.svg";
export { ForwardRef as ReactComponent };